var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._g(_vm._b({staticClass:"mt-1",staticStyle:{"cursor":"pointer"},style:(_vm.getStyle),attrs:{"src":_vm.path,"contain":""}},'img',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }